/** @format */

import React from "react";
import { Line } from 'react-chartjs-2';
import { ChartOptions } from 'chart.js';

interface ILoginChartsViewProps {
  chartData: {
    datasets: {
      label: string;
      data: { x: number; y: number }[];
      borderColor: string;
      backgroundColor: string;
      tension: number;
      pointHoverRadius: number;
      pointHitRadius: number;
    }[];
  };
  options: ChartOptions<'line'>;
}

const LoginChartsView: React.FC<ILoginChartsViewProps> = ({
  chartData,
  options,
}) => {
  return (
    <div style={{ width: '100%', height: 200, marginBottom: 10 }}>
      <Line data={chartData} options={options} />
    </div>
  );
};

export default LoginChartsView;
